import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MedicalDocumentsState } from '../models/medical-documents-state.interface';

export const selectDocumentsState = createFeatureSelector<MedicalDocumentsState>('medicalDocuments');

export const selectIsAiSearchFeatureEnabled = createSelector(selectDocumentsState, state => state.isAiSearchFeatureEnabled);
export const selectIsAiMedicalDataEnabled = createSelector(selectDocumentsState, state => state.isAiMedicalDataEnabled);
export const selectIsAiSearchChecked = createSelector(selectDocumentsState, state => state.isAiSearchChecked);
export const selectAiSearchResponseMessage = createSelector(selectDocumentsState, state => state.aiSearchResponseMessage);
export const selectIsAiSearchLoading = createSelector(selectDocumentsState, state => state.isAiSearchLoading);
export const selectDocumentsSearchTerm = createSelector(selectDocumentsState, state => state.documentsSearchTerm);

export const selectDocumentsPageConfig = createSelector(selectDocumentsState, state => state.documentsPageConfig);

export const selectDocumentsList = createSelector(selectDocumentsState, state => state.documents);
export const selectCurrentDocument = createSelector(selectDocumentsState, state => state.currentDocument);

export const selectAiDocumentsList = createSelector(selectDocumentsState, state => state.aiDocuments);
export const selectCurrentAiDocument = createSelector(selectDocumentsState, state => state.currentAiDocument);

export const selectFilteredAiDocuments = createSelector(selectAiDocumentsList, selectDocumentsSearchTerm, (aiDocuments, searchTerm) => {
  if (!searchTerm || searchTerm.length < 3) return aiDocuments;
  const lowerSearchTerm = searchTerm.toLowerCase();

  return aiDocuments.filter(
    doc =>
      doc.documentTitle?.toLowerCase().includes(lowerSearchTerm) ||
      doc.healthManagerTags?.some(tag => tag.toLowerCase().includes(lowerSearchTerm)) ||
      doc.fileName?.toLowerCase().includes(lowerSearchTerm)
  );
});

export const selectCurrentDocumentPreview = createSelector(selectDocumentsState, state => state.currentDocumentPreview);

export const selectIsDocumentsListLoading = createSelector(selectDocumentsState, state => state.isDocumentsListLoading);
export const selectIsCurrentDocumentPreviewLoading = createSelector(selectDocumentsState, state => state.isCurrentDocumentPreviewLoading);

export const selectUploadingDocuments = createSelector(selectDocumentsState, state => state.uploadingDocuments);

export const selectDocumentDetailsState = createSelector(selectDocumentsState, state => state.detailsState);

export const selectDocumentProcessingErrors = createSelector(selectDocumentsState, state => state.documentProcessingErrors);
export const selectDocumentErrors = (documentId: string) => createSelector(selectDocumentProcessingErrors, errors => errors[documentId] || []);
